import React, { ReactElement } from 'react'
import { styled } from '@mui/material'
import Chip, { ChipProps } from '@mui/material/Chip'

export interface FeatureListProps {
  featureItems: ReactElement[]
  heading: string
  className: string
}

export const FeatureChip = (props: ChipProps): JSX.Element => (
  <Chip sx={{
    fontWeight: 500,
    border: 'none',
    fontSize: 16,
    fontFamily: 'Montserrat',
  }} {...props} />
)

export const FeatureList = ({
  featureItems,
  heading,
  className,
}: FeatureListProps): JSX.Element | null => {
  const List = styled('ul')({
    display: 'flex',
    listStyle: 'none',
    marginBlock: 0,
    marginInline: 0,
    paddingInline: 0,
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    rowGap: '12px',
    '& > li': {
      minWidth: '17em',
      width: '33.33%',
      paddingRight: '0.5rem',
    },
  })

  if (featureItems.length === 0) return null

  return (
    <section className='subSection'>
      <List className={className}>{featureItems}</List>
    </section>
  )
}
